/**
 * 見積もりパネルのメーター（layout-and-navigation.md §6）。
 * 所要秒数を制限秒に対する比で塗る: ok ≤ 50%、warn ≤ 100%、over > 100%。
 * 溝は「制限の 2 倍」までを描き、超えたら右端で止めて文字で倍率を出す。
 */
import { formatRatio, OPS_PER_SECOND } from '../../lib/complexity';

export type RatioState = 'ok' | 'warn' | 'over';

export const DEFAULT_LIMIT_SEC = 2;

export interface LimitRatio {
  ratio: number;
  state: RatioState;
  /** 溝の塗り（0〜100）。溝の右端が「制限の 2 倍」。 */
  fillPercent: number;
  /** aria-valuenow 用（0〜100）。 */
  valueNow: number;
  /** 「制限の 60%」「制限の 200 倍」。 */
  text: string;
}

export function limitRatio(ops: number, limitSec = DEFAULT_LIMIT_SEC): LimitRatio {
  const seconds = ops / OPS_PER_SECOND;
  const ratio = limitSec > 0 ? seconds / limitSec : Infinity;
  const state: RatioState = ratio <= 0.5 ? 'ok' : ratio <= 1 ? 'warn' : 'over';
  const capped = Math.min(Math.max(ratio, 0), 2);
  const fillPercent = Math.max(1, (capped / 2) * 100);
  let text: string;
  if (!Number.isFinite(ratio)) text = '制限を超えます';
  else if (ratio > 1)
    text = `制限の ${formatRatio(ratio).replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 倍`;
  else if (ratio * 100 < 1) text = '制限の 1% 未満';
  else text = `制限の ${Math.round(ratio * 100)}%`;
  return { ratio, state, fillPercent, valueNow: Math.round(capped * 50), text };
}
